
import { Component, Prop, Vue } from "vue-property-decorator";
import FormItem from "@/components/DocumentViewCards/views/Card/components/forms/FormItem.vue";
import { ICOSFormCases } from "@/models/COS";
import { validateDate } from "@/utils/dates";
import { SMUser } from "@/store";

@Component({
  components: { FormItem },
})
export default class FormCOSCases extends Vue {
  @Prop({ type: Boolean, default: false }) readonly loading?: boolean;
  @Prop({ type: Object, required: true }) readonly details!: any;

  options = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  optionsYear = [
    { value: "Contract", label: "Contract" },
    { value: "Day", label: "Day" },
    { value: "Hour", label: "Hour" },
    { value: "Week", label: "Week" },
    { value: "Month", label: "Month" },
    { value: "Year", label: "Year" },
  ];

  confirm() {
    this.$emit("confirm", this.form);
  }

  created() {
    this.setCosFormCases(this.details);
  }

  get isCompliance() {
    return SMUser.isEmployer && SMUser.isSponsor;
  }

  getOtherWorkAddressesHeader(index, items) {
    const OTHER_WORK_ADDRESSES_HEADER = "Other regular work addresses in the UK";

    if (!items.length || items.length === 1) return OTHER_WORK_ADDRESSES_HEADER;

    return `${OTHER_WORK_ADDRESSES_HEADER} [${index + 1}]`;
  }

  setCosDate(date: string) {
    return date && validateDate(date) ? date : "";
  }

  setCosFormCases(data: ICOSFormCases) {
    this.form = {
      ...this.form,
      ...data,
      cos_issue_date: this.setCosDate(data.cos_issue_date),
      cos_expiry_date: this.setCosDate(data.cos_expiry_date),
      cos_work_start_date: this.setCosDate(data.cos_work_start_date),
      cos_work_end_date: this.setCosDate(data.cos_work_end_date),
      cos_sponsor_licence_number: data.cos_sponsor_licence_number ?? data.sponsor_licence_number,
      sponsor_licence_number: data.sponsor_licence_number ?? data.cos_sponsor_licence_number,
      cos_gender: data.cos_gender ?? data.gender,
      gender: data.gender ?? data.cos_gender,
    };
  }

  form: ICOSFormCases = {
    cos_tier: "",
    cos_sponsor_licence_number: "",
    cos_number: "",
    cos_issue_date: "",
    cos_expiry_date: "",
    cos_note: "",
    place_of_birth: "",
    country_of_birth: "",
    gender: "",
    national_insurance_number: "",
    employee_number: "",
    cos_work_start_date: "",
    cos_work_end_date: "",
    hours_work: "",
    job_title: "",
    job_type: "",
    job_description: "",
    if_new_entrant: "",
    basic_salary: "",
    salary_and_allowances: "",
    migrant_salary_for_each: "",
    allowances: "",
    job_title_shortage_list: false,
    maintenance_status: false,
    atas_required: false,
    if_client_contract: false,
    client_contract_details: "",
    phd_required_for_post: false,
    work_address: null,
    other_work_addresses: [],
  };
}
